module.exports = __webpack_public_path__ + "static/media/fruit-grape-2.eb413919.png";